// extracted by mini-css-extract-plugin
export default {"TruncatedItemList":"TruncatedItemList_TruncatedItemList__3Vn49"};